import { render } from "./Complete.vue?vue&type=template&id=389f709f"
import script from "./Complete.vue?vue&type=script&lang=js"
export * from "./Complete.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__